module.exports = __webpack_public_path__ + "static/media/weapon.89520783.png";